import { ThemeEvents } from '@theme/events';

/**
 * Botones del carril PDP: mismo add-to-cart que buy-buttons (clic en [ref="addToCartButton"]).
 */
function getPrimaryAddToCartButton() {
  return document.querySelector(
    '.product-information product-form-component [ref="addToCartButton"]'
  );
}

function syncOffsiderPdpAddToCartButtons() {
  const primary = getPrimaryAddToCartButton();

  document.querySelectorAll('[data-offsider-pdp-add-to-cart]').forEach((button) => {
    if (!(button instanceof HTMLButtonElement)) return;

    if (!primary) {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      return;
    }

    button.disabled = primary.disabled;
    button.setAttribute('aria-disabled', String(primary.disabled));
  });
}

function handleOffsiderPdpAddToCartClick(event) {
  const trigger = event.target instanceof Element ? event.target.closest('[data-offsider-pdp-add-to-cart]') : null;
  if (!(trigger instanceof HTMLButtonElement) || trigger.disabled) return;

  const primary = getPrimaryAddToCartButton();
  if (!(primary instanceof HTMLButtonElement) || primary.disabled) return;

  event.preventDefault();
  primary.dataset.puppet = 'true';
  primary.click();
}

function initOffsiderPdpAddToCart() {
  if (!document.querySelector('[data-offsider-pdp-add-to-cart]')) return;

  document.addEventListener('click', handleOffsiderPdpAddToCartClick);
  document.addEventListener(ThemeEvents.variantUpdate, syncOffsiderPdpAddToCartButtons);
  syncOffsiderPdpAddToCartButtons();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initOffsiderPdpAddToCart, { once: true });
} else {
  initOffsiderPdpAddToCart();
}
